import { Col, Container, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useCallback, useState } from "react";
import CopyToClipboard from "react-copy-to-clipboard";
import * as XLSX from 'xlsx';
import { BzButton, BzInputText, BzModal, BzModalBody, BzModalFooter, BzModalHeader } from "../../components";
import { toastConfig } from "../../redux/actions/toast";
import { APPLICATION_TYPE, WATCHLIST_GRID_INDEX } from "../../utils/global_variables";
import { capitalizeFirstLetter, createAndDownLoadPDF, getPageSize } from "../../utils/global_functions";
import { handleModal } from "../../redux/actions/modals";

const WatchlistShareModal = ({ headerName, rowData, columnDefs, gridRef, fileName, headerText, selectedIndices, isShareLink, isWatchlist, activeWatchList, handleShare, link, ...props }) => {
    const dispatch = useDispatch();
    const [activeOption, setActiveOption] = useState('PDF');
    const objLoginSession = useSelector(state => state?.auth?.objLoginSession);
    const handleOptionChange = (e) => {
        setActiveOption(e.target.value);
    };

    const convertToExcel = (fileName) => {
        const filterData = rowData.map(item => {
            const filterItem = {};
            columnDefs.forEach(record => {
                if (item.hasOwnProperty(record.field)) {
                    filterItem[record.headerName] = item[record.field];
                }
            });
            return filterItem;
        });
        const ws = XLSX.utils.json_to_sheet(filterData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, fileName);
        XLSX.writeFile(wb, `${fileName}.xlsx`);
    };

    const onClose = () => {
        setActiveOption('PDF');
        dispatch(handleModal([{ 'WATCHLIST_SHARE_MODAL': false }]));
    };



    const returnContent = useCallback((columnDefs, rowData) => {
        isWatchlist && (
            rowData?.forEach((eachScrip, index) => {
                if (eachScrip[WATCHLIST_GRID_INDEX.DONT_MISS]?.length > 0 && eachScrip[WATCHLIST_GRID_INDEX?.DONT_MISS_WATCHLISTS]?.length > 0) {
                    eachScrip[WATCHLIST_GRID_INDEX.DONT_MISS] = eachScrip[WATCHLIST_GRID_INDEX.DONT_MISS][0]?.event;
                    eachScrip[WATCHLIST_GRID_INDEX.DONT_MISS_WATCHLISTS] = '';
                } else { }
            })
        );
        return [
            headerText,
            {
                absolutePosition: { x: 40, y: 65 },
                table: {
                    // margin:[1000,0,0,0],
                    body: [
                        columnDefs?.map((col) => ({ text: col.headerName ? capitalizeFirstLetter(col.headerName) : capitalizeFirstLetter(col.field), style: 'columnStyle', borderColor: ['#F1F1F1', '#F1F1F1', '#F1F1F1', '#F1F1F1'] })),
                        ...rowData?.map((row, index) => columnDefs?.map((col, rowIndex) => ({

                            text: row[col.field], style: index % 2 === 0 ? 'evenRowStyle' : 'oddRowStyle', borderColor: ['#F1F1F1', '#F1F1F1', '#F1F1F1', '#F1F1F1'],
                            bold: (rowIndex === 0) ? true : false
                        })))
                    ],
                },
            },
        ];
    }, [rowData, activeWatchList]);

    const handleDownload = useCallback(() => {
        const colDef = columnDefs.slice(1);
        let content = returnContent(colDef, rowData);
        let styles = {
            columnStyle: {
                fillColor: '#EBF2FE',
                color: '#303030',
                fontSize: 12,
                margin: [5, 5, 5, 5],
                bold: true,
            },
            evenRowStyle: {
                fillColor: '#F9FBFF',
                fontSize: 12,
                margin: [5, 5, 5, 5]
            },
            oddRowStyle: {
                fillColor: 'white',
                fontSize: 12,
                margin: [5, 5, 5, 5]
            },

        };

        if (activeOption === 'PDF') {
            if (Object?.values(rowData)?.length) {
                let paperSize = getPageSize(columnDefs);
                createAndDownLoadPDF(fileName, paperSize, 'landscape', content, styles);
            }
        } else if (activeOption === 'EXCEL') {
            convertToExcel(fileName);
        }
        onClose();
    }, [activeOption, rowData, columnDefs, convertToExcel, objLoginSession, onClose, returnContent]);

    const handleCopy = () => {
        dispatch(toastConfig({ autoDismiss: true, show: true, message: 'Link copied to clipboard' }));
    };

    return (
        <BzModal size='sm' centered show={true} onHide={onClose} className='modal-breeze'>
            <BzModalHeader className='modaltabs-header bdr-none'>
                <Container fluid className='p-0'>
                    <Row className='g-0'>
                        <Col md={11} className='d-flex justify-content-start align-items-center'>
                            <div className='font-medium font-size4 color-text'>{headerName}</div>
                        </Col>
                        <Col md={1} className='d-flex justify-content-end align-items-center'>
                            <div onClick={onClose} className='icon-16 icon-close icon-dark'></div>
                        </Col>
                    </Row>
                </Container>
            </BzModalHeader>
            <BzModalBody>
                <Container fluid className='p-0'>
                    <Row className='g-0 mb-3'>
                        <Col className='d-flex justify-content-start align-items-start'>
                            <div className='font-regular font-size3 color-text'>Choose format:</div>
                        </Col>
                    </Row>
                    <Row className='g-0 mb-3'>
                        <Col md={1} className='d-flex justify-content-start align-items-center'>
                            <input type="radio" className='form-check-input m-0' value="PDF"
                                checked={activeOption === 'PDF'} onChange={handleOptionChange} />
                        </Col>
                        <Col className='d-flex justify-content-start align-items-center'>
                            <div className='font-medium font-size4 color-text'>PDF</div>
                        </Col>
                    </Row>
                    <Row className='g-0 mb-3'>
                        <Col md={1} className='d-flex justify-content-start align-items-center'>
                            <input type="radio" className='form-check-input m-0' value="EXCEL"
                                onChange={handleOptionChange} checked={activeOption === 'EXCEL'} />
                        </Col>
                        <Col className='d-flex justify-content-start align-items-center'>
                            <div className='font-medium font-size4 color-text'>Excel</div>
                        </Col>
                    </Row>
                    {isShareLink && (
                        <>
                            <Row className='g-0 mb-4'>
                                <Col md={1} className='d-flex justify-content-start align-items-center'>
                                    <input type="radio" className='form-check-input m-0' value="UAT"
                                        onChange={handleOptionChange} checked={activeOption === 'UAT'} />
                                </Col>
                                <Col className='d-flex justify-content-start align-items-center'>
                                    <div className='font-medium font-size4 color-text'>{`${APPLICATION_TYPE} WEB`}</div>
                                </Col>
                            </Row>
                            {activeOption === 'UAT' ?
                                <Row className='g-0 mb-3'>
                                    <Col className='d-flex flex-column justify-content-start align-items-start'>
                                        <div className='font-regular font-size3 color-text mb-2'>Copy link to clipboard:</div>
                                        <div className='input-group'>
                                            <BzInputText type="text" placeholder='Name your watchlist' className='font-regular color-text text-uppercase' value={link} disabled={true} />
                                        </div>
                                    </Col>
                                </Row>
                                : null}
                        </>
                    )}
                </Container>
            </BzModalBody>
            <BzModalFooter>
                <Container fluid className='p-0 m-0'>
                    {activeOption === 'UAT' && isShareLink ?
                        <Row className='g-0'>
                            <Col className='d-flex'>
                                <CopyToClipboard text={link}>
                                    <BzButton type="reset" className='btn btn-md btn-block btn-outline me-3' onClick={handleCopy}>COPY LINK</BzButton>
                                </CopyToClipboard>
                                <BzButton type="submit" className='btn btn-md btn-primary btn-block ms-3' onClick={handleShare}>SHARE</BzButton>
                            </Col>
                        </Row> :
                        <Row className='g-0'>
                            <Col className='d-flex justify-content-end'>
                                <BzButton type="reset" className='btn btn-md btn-primary' onClick={handleDownload}>DOWNLOAD</BzButton>
                            </Col>
                        </Row>
                    }
                </Container>
            </BzModalFooter>
        </BzModal>
    );
};

export default WatchlistShareModal;